// global vars
let g_dev = false;
let g_windowHeight = $(window).height();
let g_windowWidth = $(window).width();
let g_scroll = $(window).scrollTop();

// custom vars
let scrollMargin = 20;
let scrollTreshold = 25;

$(window).on('scroll', function () {
    g_scroll = $(window).scrollTop();
});

// On windows.resize
$(window).on('resize', function () {
    // Set window height/width on resize
    g_windowHeight = $(window).height();
    g_windowWidth = $(window).width();
});


// Unsorted
function sliderHeight() {
    $('.slider-history').each(function () {
        var slideImageHeight = ($(this).find('.slide-item-image').first().height() / 2) - 20;

        if ($(this).find('.slick-arrow').length() > 0) {
            $(this).find('.slick-arrow').css('top', slideImageHeight);
        }
    });
}

$(document).ready(function () {
    scrollAnimate();
    setTimeout(function () {
        scrollAnimate();
    }, 500);

    lazyEmbed();
    playVideo();
    resizeTitles();
    cookieMargin();
    $(window).on('resize', function () {
        resizeTitles();
        cookieMargin();
    })

    $(window).on('scroll', function () {
        scrollAnimate();
    })
})

$(window).on('load', function() {
    contentSideImage1();
    contentSideImage2();
})

$(window).on('resize', function() {
    contentSideImage1();
    contentSideImage2();
})

function playVideo() {
    $('[data-play-video]').on('click', function() {
        $(this).closest('.video').find('video').trigger('play');
    })
}

function contentSideImage1() {
    var positionLeft = $('.content-side-image-1').offset().left;

    var imageWidth = (g_windowWidth - positionLeft);

    if(g_windowWidth > 768) {
        $('.content-side-image-1').width(imageWidth);
    } else {
        $('.content-side-image-1').width('');
    }

    var containerHeight = $('.content-side-image-1').closest('.content-section').outerHeight();
    var imageHeight = $('.content-side-image-1').outerHeight();
    var positionTop = (containerHeight - imageHeight) + 24;

    var scaledImageWidth = $('.content-side-image-1').outerWidth();

    var scaledPositionLeft = ((g_windowWidth - positionLeft) - scaledImageWidth + 24);

    if(g_windowWidth > 768) {
        // $('.content-side-image-1').css('top', positionTop);
        $('.content-side-image-1').css('left', scaledPositionLeft);
    } else {
        // $('.content-side-image-1').css('top', '');
        $('.content-side-image-1').css('left', '');
    }


}

function contentSideImage2() {
    var positionLeft = $('.content-side-image-2').offset().left;

    var imageWidth = (g_windowWidth - positionLeft);

    if(g_windowWidth > 768) {
        $('.content-side-image-2').width(imageWidth);
    } else {
        $('.content-side-image-2').width('');
    }
}

function lazyEmbed() {
    $('.embed-responsive').on('click', function() {
        var iframeSrc = $(this).find('iframe').attr('data-src');
        $(this).find('iframe').removeAttr('data-src');
        $(this).find('iframe').attr('src', iframeSrc);
    });
}

function cookieMargin() {
    if($('.cookies-section').length) {
        var cookieHeight = $('.cookies-section').outerHeight();
        var headerHeight = $('.header-section').outerHeight();
        var totalHeight = cookieHeight + headerHeight;
        $('.header-section').css('top', cookieHeight);
        $('.login-section').css({'margin-top': (cookieHeight + headerHeight), 'max-height': 'calc(100vh - ' + totalHeight + 'px)'});
        $('.menu-section').css({'margin-top': (cookieHeight + headerHeight), 'max-height': 'calc(100vh - ' + totalHeight + 'px)'});
        $('body').css('padding-top', (cookieHeight + headerHeight));
    }
}

function splitLines(container, opentag, closingtag) {
    var spans = container.children,
        top = 0,
        tmp = '';

    container.innerHTML = container.textContent.replace(/\S+/g, '<n>$&</n>');
    for (let i = 0; i < spans.length; i++) {
        var rect = spans[i].getBoundingClientRect().top;
        if (top < rect) tmp += closingtag + opentag;
        top = rect;
        tmp += spans[i].textContent + ' ';
    }

    container.innerHTML = tmp += closingtag;
}

// Title with Logo
function resizeTitles() {
    if($('.title-with-logo-wrapper').length === 1) {
        splitLines(document.querySelectorAll('.title-with-logo-wrapper .title')[0], '<span class="line">', '</span>');
    }
    if($('.title-with-logo-wrapper').length === 2) {
        splitLines(document.querySelectorAll('.title-with-logo-wrapper .title')[0], '<span class="line">', '</span>');
        splitLines(document.querySelectorAll('.title-with-logo-wrapper .title')[1], '<span class="line">', '</span>');
    }
    if($('.title-with-logo-wrapper').length === 3) {
        splitLines(document.querySelectorAll('.title-with-logo-wrapper .title')[0], '<span class="line">', '</span>');
        splitLines(document.querySelectorAll('.title-with-logo-wrapper .title')[1], '<span class="line">', '</span>');
        splitLines(document.querySelectorAll('.title-with-logo-wrapper .title')[2], '<span class="line">', '</span>');
    }

    if($('.title-with-logo-wrapper-small').length > 0) {
        splitLines(document.querySelectorAll('.title-with-logo-wrapper-small .title')[0], '<span class="line">', '</span>');
    }
}

function scrollAnimate() {
    $('[data-animate]').each(function () {
        var scrollTrigger = (g_scroll + g_windowHeight);
        var scrollTriggerHeight = (g_windowHeight * 0.75);
        var elementStart = (Math.ceil($(this).offset().top));
        var startValue = 0.8;

        var scrollPercentage = (scrollTrigger - Math.ceil($(this).offset().top));

        var animateValue = (startValue + ((1 - startValue) / scrollTriggerHeight) * scrollPercentage);

        if ((scrollTrigger > elementStart) && (scrollTrigger < (elementStart + scrollTriggerHeight))) {
            // $('.body-section').css('opacity', animateValue);
            $(this).css('transform', 'scale(' + animateValue + ')');
        }
    });

}


